import React from 'react';
import { ActivityIcon, CalendarIcon, PillIcon, BookOpenIcon, TrophyIcon, TimerIcon, TrendingUpIcon, BellIcon, ArrowRightIcon } from 'lucide-react';
import { FeatureCard } from '../ui/FeatureCard';
import { MetricCard } from '../ui/MetricCard';
import { ProtocolCard } from '../ui/ProtocolCard';
interface DashboardProps {
  onNavigate: (screen: string) => void;
}
export const Dashboard: React.FC<DashboardProps> = ({
  onNavigate
}) => {
  return <div className="p-4 md:p-6 lg:ml-64 pb-16 lg:pb-6" data-id="element-12">
      <div className="mb-6" data-id="element-13">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-14">
          Guten Morgen, Julia
        </h1>
        <p className="text-gray-600" data-id="element-15">
          Dein BioAge heute:{' '}
          <span className="font-semibold text-purple-600" data-id="element-16">32.4 Jahre</span>{' '}
          (chronologisch: 35)
        </p>
      </div>
      {/* Today's Protocol */}
      <section className="mb-8" data-id="element-17">
        <div className="flex justify-between items-center mb-4" data-id="element-18">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-19">
            Dein Protokoll heute
          </h2>
          <button onClick={() => onNavigate('protocols')} className="text-purple-600 flex items-center text-sm font-medium" data-id="element-20">
            Mehr <ArrowRightIcon size={16} className="ml-1" data-id="element-21" />
          </button>
        </div>
        <ProtocolCard title="Regenerationstag" description="Dein Schlaf war letzte Nacht nicht optimal. Fokussiere dich heute auf Regeneration." progress={30} tasks={[{
        title: 'Morgen-Meditation',
        completed: true
      }, {
        title: 'Magnesium-Supplement',
        completed: false
      }, {
        title: 'Leichte Bewegung (20 Min.)',
        completed: false
      }, {
        title: 'Früh schlafen gehen',
        completed: false
      }]} data-id="element-22" />
      </section>
      {/* Key Metrics */}
      <section className="mb-8" data-id="element-23">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-24">
          Deine Werte
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-25">
          <MetricCard title="Schlaf" value="6.2h" change="-12%" status="negative" onClick={() => onNavigate('bioage')} data-id="element-26" />
          <MetricCard title="HRV" value="42ms" change="+5%" status="positive" onClick={() => onNavigate('bioage')} data-id="element-27" />
          <MetricCard title="Stimmung" value="Gut" change="stabil" status="neutral" onClick={() => onNavigate('mood')} data-id="element-28" />
          <MetricCard title="Aktivität" value="3.2k" change="-8%" status="negative" onClick={() => onNavigate('bioage')} data-id="element-29" />
        </div>
      </section>
      {/* Upcoming */}
      <section className="mb-8" data-id="element-30">
        <div className="flex justify-between items-center mb-4" data-id="element-31">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-32">Anstehend</h2>
          <span className="bg-purple-100 text-purple-600 text-xs px-2 py-1 rounded-full" data-id="element-33">
            3 Aktivitäten
          </span>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4 space-y-4" data-id="element-34">
          <div className="flex items-center" data-id="element-35">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-36">
              <PillIcon size={18} className="text-blue-600" data-id="element-37" />
            </div>
            <div className="flex-1" data-id="element-38">
              <p className="text-gray-800 font-medium" data-id="element-39">NAD+ Supplement</p>
              <p className="text-gray-500 text-sm" data-id="element-40">In 25 Minuten</p>
            </div>
            <button className="text-purple-600 text-sm font-medium" data-id="element-41">
              Nehmen
            </button>
          </div>
          <div className="flex items-center" data-id="element-42">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-43">
              <TimerIcon size={18} className="text-green-600" data-id="element-44" />
            </div>
            <div className="flex-1" data-id="element-45">
              <p className="text-gray-800 font-medium" data-id="element-46">Fastenzeit endet</p>
              <p className="text-gray-500 text-sm" data-id="element-47">
                In 1h 15min (16:8 Intervall)
              </p>
            </div>
            <button className="text-purple-600 text-sm font-medium" data-id="element-48">
              Details
            </button>
          </div>
          <div className="flex items-center" data-id="element-49">
            <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-50">
              <TrophyIcon size={18} className="text-orange-600" data-id="element-51" />
            </div>
            <div className="flex-1" data-id="element-52">
              <p className="text-gray-800 font-medium" data-id="element-53">Kältechallenge: Tag 4</p>
              <p className="text-gray-500 text-sm" data-id="element-54">Kalte Dusche (30 Sek.)</p>
            </div>
            <button className="text-purple-600 text-sm font-medium" data-id="element-55">
              Starten
            </button>
          </div>
        </div>
      </section>
      {/* Features */}
      <section data-id="element-56">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-57">
          Entdecke AYA
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-58">
          <FeatureCard icon={ActivityIcon} title="BioAge Analyzer" color="blue" onClick={() => onNavigate('bioage')} data-id="element-59" />
          <FeatureCard icon={PillIcon} title="Supplements" color="purple" onClick={() => onNavigate('supplements')} data-id="element-60" />
          <FeatureCard icon={BookOpenIcon} title="Ageless Wissen" color="green" onClick={() => onNavigate('wissen')} data-id="element-61" />
          <FeatureCard icon={TrophyIcon} title="Challenges" color="orange" onClick={() => onNavigate('challenges')} data-id="element-62" />
          <FeatureCard icon={TimerIcon} title="Fasten & Ernährung" color="red" onClick={() => onNavigate('fasting')} data-id="element-63" />
          <FeatureCard icon={TrendingUpIcon} title="Smart Labs" color="indigo" onClick={() => onNavigate('labs')} data-id="element-64" />
        </div>
      </section>
    </div>;
};